export const CommentTypes = {
  SALE_LOT: "SaleLot",
  NOMINATION: "Nomination",
  RECEIVAL_LOT: "ReceivalLot",
  PEN_SCAN_LOT: "PenScanLot",
  DEPLOYMENT_SALE: "DeploymentSale",
  WEIGH_LOT: "WeighLot",
};
